export default "__VITE_ASSET__b49667b7__"